import { useParams } from 'react-router-dom';
import styles from '../Museum.module.scss';

export const Digital = ({ upPage }) => {
  const { lang } = useParams();
  const { toptitle, title, text, items, qr } = upPage.acf.digital;

  return (
    <section className={styles.digital}>
      <div className="container">
        <div className={styles.digital_body}>
          <div className={styles.digital_info}>
            <h3 className={`${styles.digital_info_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
            <h2 className={`${styles.digital_info_title} global-title`}>{title[lang]}</h2>
            <p className={`${styles.digital_info_text} global-text`}>{text[lang]}</p>
            <div className={styles.digital_info_row}>
              {items.map((el, idx) => {
                const { icon, title, text } = el;
                return (
                  <div key={idx} className={styles.digital_column}>
                    <div className={styles.digital_column_body}>
                      <div className={styles.digital_column_icon}>{icon}</div>
                      <div className={styles.digital_column_content}>
                        <div className={styles.digital_column_title}>{title[lang]}</div>
                        <div className={`${styles.digital_column_text} global-text`}>{text[lang]}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.digital_contact}>
            <div className={`${styles.digital_contact_qr} ${!qr.img ? 'active' : ''}`}>{qr.img ? <img src={qr.img} alt="qr" /> : '📷'}</div>
            <h4 className={styles.digital_contact_title}>{qr.title[lang]}</h4>
            <p className={`${styles.digital_contact_text} global-text`}>{qr.text[lang]}</p>
            <a href="https://bokeylibrary.kz" target="_black" className={styles.digital_contact_link}>
              🔗 bokeylibrary.kz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
